<template>
  <div>
    <a-divider orientation="left">
      <a-badge status="default" v-if="saibs[0].status === 0" />
      <a-badge status="processing" v-if="saibs[0].status === 1" />
      <a-badge status="success" v-if="saibs[0].status === 2" />
      <a-badge status="error" v-if="saibs[0].status === 3" />
      <a-badge status="warning" v-if="saibs[0].status === 4" />
      {{
      `${saibs[0].wholesale.name} - ${saibs[0].wholesale.location.floor}층 ${
      saibs[0].wholesale.location.row
      }열 ${saibs[0].wholesale.location.place}호 (${
      saibs[0].type === 0 ? '사입' : '교환 / 반납'
      })`
      }}
      <br v-if="!isPC" />
      <b>{{ $moment(saibs[0].uploadAt).format('llll') }}</b>
    </a-divider>
    <table class="list-type-2">
      <thead>
        <tr>
          <td v-if="!isPC">상세 내용</td>
          <td v-if="isPC">주문 내역</td>
          <td v-if="isPC">메세지</td>
          <td v-if="isPC">금액</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="saib in saibs" :key="saib.idx">
          <td v-if="isPC" class="order-detail">
            {{ saib.detail.name }}
            <a-badge :count="'×' + saib.detail.amount" />
          </td>
          <td v-if="isPC">{{ saib.detail.reason || '해당 없음' }}</td>
          <td v-if="isPC">{{ parseInt(saib.detail.price || '0').toLocaleString() }}원</td>
          <td v-else style="text-align: left; padding: 1em;">
            <dl>
              <dt>주문 내역:</dt>
              <dd>
                {{ saib.detail.name }}
                <a-badge :count="'×' + saib.detail.amount" />
              </dd>
              <dt>메세지:</dt>
              <dd>{{ saib.detail.reason || '해당 없음' }}</dd>
              <dt>금액:</dt>
              <dd>{{ parseInt(saib.detail.price || '0').toLocaleString() }}원</dd>
            </dl>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "LogItem",
  props: ["saibs"]
};
</script>
